export enum ButtonType{
  PRIMARY = "css-btn-primary",
  SECONDARY = "css-btn-secondary"
}
